let scrollRequested = false;

/** Asks the Advanced tab's futures-on-spot toggle to scroll into view once
 * that tab shows, since it sits below the limits. Scrolling earlier misses:
 * the tab's layout is still settling. */
export const scrollToFuturesAsSpotToggle = () => {
  scrollRequested = true;
};

/** Whether a scroll was requested, clearing the request. */
export const takeFuturesAsSpotScrollRequest = () => {
  const requested = scrollRequested;
  scrollRequested = false;
  return requested;
};
